(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$.fn.dropdownMenu = function() {

		var generateDropdownToggle = function(dropdownMenus) {
			dropdownMenus.each(function () {
				var dropdown = $(this);
				var parentMenu = dropdown.parent();

				if (parentMenu.is('.disable--link')) {
					var toggler = parentMenu.find('a:first');
				} else {
					var toggler = $('<a href="#" class="dropdown-toggle"></a>').insertBefore(dropdown);
				}

				toggler.click(function (e) {
					e.preventDefault();

					parentMenu.toggleClass('open');
				});

				if ((parentMenu.is('.active-parent') || parentMenu.is('.active-ancestor')) && !parentMenu.is('.reset-dropdown')) {
					parentMenu.addClass('open');
				}
			});
		}

		return this.each(function () {
			var menu = $(this);
			var dropdownMenus = menu.find('ul.dropdown-menu');

			generateDropdownToggle(dropdownMenus);
		});
	};

	$('#header nav').dropdownMenu();
	$('#header #top-right-menu').dropdownMenu();

})();
